import React, { FunctionComponent, CSSProperties } from 'react';
import { Trans } from 'react-i18next';
import { TFunction } from 'i18next';

interface Props {
  t: TFunction;
  i18nKey: string;
  termsLink?: string;
  privacyLink?: string;
  termsStyles?: CSSProperties;
  privacyStyles?: CSSProperties;
}

const Terms: FunctionComponent<Props> = ({ t, i18nKey, termsLink, privacyLink, termsStyles, privacyStyles }) => (
  <Trans t={t} i18nKey={i18nKey}>
    <a href={termsLink} style={termsStyles} target="_blank" rel="noopener noreferrer">
      AGB
    </a>
    <a href={privacyLink} style={privacyStyles} target="_blank" rel="noopener noreferrer">
      Datenschutz
    </a>
  </Trans>
);

Terms.defaultProps = {
  termsLink: 'https://www.mineko.de/agb/',
  privacyLink: 'https://www.mineko.de/datenschutz/',
};

export default Terms;
